export default defineAppConfig({
  title: 'azgo',
})
